import React, {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import cx from 'classnames'

import { clearHtml } from '../../../lib/utils'

import css from './ReviewText.module.scss'
import { IProduct } from '../../types'
import Link from 'next/link'
import ArrowIcon from '../../../public/static/icons/arrow-without-stick.svg'

interface IReviewText {
  text: string
  setShowFull?: Dispatch<SetStateAction<boolean>>
  product?: IProduct
}

const ReviewText: FC<IReviewText> = ({ text, setShowFull, product }) => {
  const containerRef = useRef<HTMLDivElement>()
  const textRef = useRef<HTMLDivElement>()

  const [textHidden, setTextHidden] = useState(true)
  const [shouldShowButton, setShouldShowButton] = useState(false)

  function updateHeight() {
    const height = textRef.current.offsetHeight
    const containerHeight = containerRef.current.offsetHeight

    setShowFull(containerHeight > height || containerHeight === height)
    setShouldShowButton(containerHeight < height)
  }

  useEffect(() => {
    if (!containerRef.current || !textRef.current) {
      return
    }

    updateHeight()

    window.addEventListener('resize', updateHeight)

    return () => {
      window.removeEventListener('resize', updateHeight)
    }
  }, [containerRef.current, textRef.current])

  return (
    <div>
      {product && (
        <>
          <p className={css.productName}>{product.name}</p>
          {product?.href && (
            <Link href={product.href}>
              <a className={css.productLink}>
                Перейти к товару <ArrowIcon />
              </a>
            </Link>
          )}
        </>
      )}
      <div
        ref={containerRef}
        className={cx(css.reviewTextContainer, {
          [css.open]: (setShowFull && !setShouldShowButton) || !textHidden,
        })}
      >
        <div
          ref={textRef}
          className={css.reviewText}
          dangerouslySetInnerHTML={{ __html: clearHtml(text) }}
        />
        {textHidden && shouldShowButton && (
          <button
            className={css.reviewTextButton}
            onClick={() => {
              setTextHidden(false)
              setShowFull(true)
            }}
          >
            Читать еще
          </button>
        )}
      </div>
    </div>
  )
}

export default ReviewText
